import { NavigateFunction, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { Skeleton, Spin } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faEdit } from "@fortawesome/free-solid-svg-icons";
import { LinkButton } from "../LinkButton";
import { memo, useMemo } from "react";

interface DefaultEntityPageProps {
  query: Function;
  entityName: string;
  entityPresenter: (record: any) => string;
  uneditable?: Boolean;
  customActions?: ((record: any, navigate: NavigateFunction) => React.ReactNode)[];
}

const DefaultEntityPage = memo(({ query, entityName, entityPresenter, uneditable, customActions }: DefaultEntityPageProps) => {
  const location = useLocation();
  const navigate = useNavigate();

  const params = useParams();
  const recordId = useMemo(() => (params.recordId ? params.recordId : "0"), [params.recordId]);

  const { data: record, isLoading, isFetching } = query(recordId);

  if (isLoading) {
    return <Skeleton active />;
  }

  return (
    <Spin spinning={isFetching}>
      <div className="flex border-b mb-5 p-2 border-gray-300" style={{ borderBottomStyle: "solid" }}>
        <h4
          className="flex-auto m-0 cursor-pointer"
          onClick={() => navigate(location.pathname.substring(0, location.pathname.indexOf(recordId) + recordId.length), { state: location.state })}>
          {entityName} <span className="text-violet-500">{record ? entityPresenter(record) : "..."}</span>
        </h4>

        {!uneditable &&
          (location.pathname.includes("edit") ? (
            <LinkButton
              title="لغو ویرایش و بازگشت به صفحه جزییات"
              to={location.pathname.replace("/edit", "")}
              icon={<FontAwesomeIcon className="anticon align-middle" icon={faArrowRight} />}>
              لغو
            </LinkButton>
          ) : (
            <div className="flex flex-wrap gap-1">
              <LinkButton to="edit" icon={<FontAwesomeIcon className="anticon align-middle" icon={faEdit} title="ویرایش" />}>
                ویرایش
              </LinkButton>
              {customActions?.map((x, i) => x(record, navigate))}
            </div>
          ))}
      </div>
      <div>
        <Outlet />
      </div>
    </Spin>
  );
});

export const GetDefaultEntityPage =
  ({ query, entityName, entityPresenter, uneditable, customActions }: DefaultEntityPageProps) =>
  () =>
    (
      <DefaultEntityPage
        query={query}
        entityName={entityName}
        entityPresenter={entityPresenter}
        uneditable={uneditable}
        customActions={customActions}
      />
    );
